@if (showWorkflowInstanceSelector) {
    <div class="instance-select">
        <div class="instance-select__wrapper">
            <app-select
                label="Workflow Instance"
                placeholder="Select Instance"
                [dataQa]="dataQa.workflowInstanceSelect"
                [options]="workflowInstanceOptions"
                [value]="selectedWorkflow"
                (selectionChange)="onWorkflowInstanceChange($event)" />
        </div>
    </div>
}
@if (workflowSelectionRequired) {
    <span class="workflow-selection-message color-gray12">
        Please select a workflow instance to display inbox items.
    </span>
} @else {
    <div class="filter-select grid grap-10 items-start">
        <app-status-filter
            [statusChips]="statusChipsData"
            [selectedStatuses]="selectedStates"
            (filterChange)="onStatusFilterChange($event)" />
        <app-toggle
            id="showMyItemsToggle"
            label="Show only my items"
            [dataQa]="dataQa.showOnlyMyItemsToggle"
            [initialToggled]="showMyItems"
            (toggledTo)="onToggleMyItems($event)" />
    </div>
    <div>
        <div class="flex justify-space-between items-center">
            <div class="flex gap-10">
                <app-flat-button
                    variant="tertiary"
                    [disabled]="!canDoBulkAction"
                    [dataQa]="dataQa.bulkTakeButton"
                    (clicked)="openTakeConfirmDialog()">
                    Take
                </app-flat-button>
                @if (showBulkActionButtons) {
                    <app-flat-button
                        variant="tertiary"
                        [disabled]="!canDoBulkAction"
                        [dataQa]="dataQa.bulkAssignButton"
                        (clicked)="openAssignConfirmDialog()">
                        Assign
                    </app-flat-button>
                    <app-flat-button
                        variant="tertiary"
                        [disabled]="!canDoBulkAction"
                        [dataQa]="dataQa.bulkUnassignButton"
                        (clicked)="openUnassignConfirmDialog()">
                        Unassign
                    </app-flat-button>
                }
                <mat-divider [vertical]="true" />
                <app-flat-button
                    variant="tertiary"
                    [disabled]="!canDoBulkAction"
                    [dataQa]="dataQa.bulkRenotifyButton"
                    (clicked)="renotify()">
                    Re-Notify
                </app-flat-button>
            </div>
            <div class="flex items-center">
                <app-text-button
                    [dataQa]="dataQa.openExcelDialogButton"
                    (clicked)="onExportClicked()">
                    Export
                </app-text-button>
                <app-table-view-menu
                    [selected]="selectedTableView"
                    [docOptions]="docViewColumnOptions"
                    [nestedDocOptions]="docViewNestedColumnOptions"
                    [discOptions]="discViewColumnOptions"
                    (docOptionsChanged)="updateColumnDisplay($event)"
                    (disccOptionsChanged)="updateDiscColumnDisplay($event)"
                    (nestedDocOptionsChanged)="
                        updateNestedColumnDisplay($event)
                    "
                    (tableViewChanged)="onTableViewChanged($event)" />
                <app-text-button
                    [dataQa]="dataQa.resetFiltersButton"
                    [disabled]="isResetFiltersDisabled()"
                    (clicked)="resetFilters()">
                    Reset filters
                </app-text-button>
            </div>
        </div>
    </div>

    @if (showDocuments && !inboxChoicesLoading) {
        <div>
            @if (selectedTableView === TableView.Document) {
                <app-document-view
                    [workflowAndRepo]="workflowAndRepo"
                    [states]="selectedStates"
                    [showMyItems]="showMyItems" />
            }
            @if (selectedTableView === TableView.Discrepancy) {
                <app-discrepancy-view
                    [workflowAndRepo]="workflowAndRepo"
                    [states]="selectedStates"
                    [showMyItems]="showMyItems" />
            }
        </div>
    }
}

@if (selectedDocument) {
    <div style="height: 45vh"></div>
    <app-summary-panel
        [documentId]="selectedDocument"
        (panelClose)="closePanel()" />
}

@if (loading || bulkLoading) {
    <app-loader type="overlay" />
}
